import { z } from 'zod'
import { oc } from '@orpc/contract'

// Triage an incoming fax as a plain Document (administrative paperwork, PD-1869):
// files the fax onto the patient's chart under `title`, without the lab result,
// order, Care Queue task or patient email that the Labs/Imaging triage creates.
export const triageIncomingFaxDocument = oc
  .route({ method: 'POST', path: '/v2/incoming-faxes/{id}/triage-document' })
  .input(
    z.object({
      id: z.string(),
      patientId: z.string(),
      title: z.string().trim().min(1),
    }),
  )
  .output(z.object({ documentReferenceId: z.string() }))
